module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "20px",
      "padding-bottom": "20px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "2.76667in",
      "height": "3.74028in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Melek was educated at Bath College, University of Bath, England. She taught shorthand, keyboarding, and English as a second language at Camden Secretarial College, and English at Bath College for foreign students.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("She loves to travel to various countries, meeting people from all walks of life as well as enjoying the beautiful scenery and cultural cuisine.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Her journeys over the years have brought many memories that include instructing swimming in England and instructing belly dancing in Egypt and the USA for healthy living.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256644c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0